<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>商品基础信息设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>商品基础信息设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>商品名称：</p>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname"
                placeholder="输入商品中文名称"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_e"
                placeholder="Enter product name"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_m"
                placeholder="Nhập tên sản phẩm"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_y"
                placeholder="Masukkan nama produk"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.commodityname_t"
                placeholder="ป้อนชื่อสินค้า"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>商品简称</p>
            <div class="input_box">
              <el-input
                v-model="formData.shortname"
                placeholder="输入商品中文名称"
                maxlength="30"
              ></el-input>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.shortname_e"
                placeholder="Enter product name"
                maxlength="30"
              />
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.shortname_m"
                placeholder="Nhập tên sản phẩm"
                maxlength="30"
              />
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.shortname_y"
                placeholder="Masukkan nama produk"
                maxlength="30"
              />
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.shortname_t"
                placeholder="ป้อนชื่อสินค้า"
                maxlength="30"
              />
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>商品类型</p>
            <div class="select_box">
              <el-select
                v-model="formData.comtype"
                placeholder="请选择商品类型"
              >
                <el-option
                  v-for="item in columnsGoodsType"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>商品所属分类</p>
            <div class="select_box">
              <el-select
                v-model="formData.labelid"
                placeholder="请选择一级分类"
                @change="handleChangeLabel1"
              >
                <el-option
                  v-for="item in labelChilds1"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.labelid2"
                placeholder="请选择二级分类"
                @change="handleChangeLabel2"
              >
                <el-option
                  v-for="item in labelChilds2"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.labelid3"
                placeholder="请选择三级分类"
              >
                <el-option
                  v-for="item in labelChilds3"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>商品结算类型</p>
            <div class="select_box">
              <el-select
                v-model="formData.paytype"
                placeholder="请选择商品结算类型"
              >
                <el-option
                  v-for="item in columnsGoodsSettleType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>商品SKU采购编码：</h1>
            <p>{{ detail.sku }}</p>
          </div>
          <div class="item">
            <h1>商品ISBN编码：</h1>
            <p>{{ detail.ISBN }}</p>
          </div>
          <div class="item">
            <h1>商品品牌：</h1>
            <p>{{ detail.brandname }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import {
  getCommidityDetail,
  getCommondityLabel,
  editCommidity,
  encryptstringview,
} from "../../../api/api";
export default {
  name: "cBaseinfo",
  data() {
    return {
      loading: false,
      columnsGoodsType: [
        "普通商品",
        "普通用户积分礼品",
        "商务用户积分礼品",
        "企业积分商品",
      ],
      columnsGoodsSettleType: [
        { value: "零售或批发购买", label: "零售或批发购买" },
        { value: "普通用户积分兑换", label: "普通用户积分兑换" },
        { value: "商户合作用户积分兑换", label: "商户合作用户积分兑换" },
        { value: "企业积分", label: "企业积分" },
      ],

      allLabel: [],
      labelChilds1: [],
      labelChilds2: [],
      labelChilds3: [],

      id: '',
      detail: "",
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        commodityname: "",
        commodityname_e: "",
        commodityname_m: "",
        commodityname_y: "",
        commodityname_t: "",
        shortname: "",
        shortname_e: "",
        shortname_m: "",
        shortname_y: "",
        shortname_t: "",
        comtype: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
        paytype: "",
      },
    };
  },
  created() {
    let { routerList, OPENID} = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id
        this.getShopLabel();
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      this.loading = true;
      getCommidityDetail({ id: this.id }).then((res) => {
        this.detail = res;
        this.formData.id = res.id ? res.id : "";
        this.formData.commodityname = res.commodityname
          ? res.commodityname
          : "";
        this.formData.commodityname_e = res.commodityname_e
          ? res.commodityname_e
          : "";
        this.formData.commodityname_m = res.commodityname_m
          ? res.commodityname_m
          : "";
        this.formData.commodityname_y = res.commodityname_y
          ? res.commodityname_y
          : "";
        this.formData.commodityname_t = res.commodityname_t
          ? res.commodityname_t
          : "";
        this.formData.shortname = res.shortname ? res.shortname : "";
        this.formData.shortname_e = res.shortname_e ? res.shortname_e : "";
        this.formData.shortname_m = res.shortname_m ? res.shortname_m : "";
        this.formData.shortname_y = res.shortname_y ? res.shortname_y : "";
        this.formData.shortname_t = res.shortname_t ? res.shortname_t : "";
        this.formData.comtype = res.comtype ? res.comtype : "";
        this.formData.labelid = res.labelid ? res.labelid : "";
        if (res.labelid) {
          this.handleChangeLabel1(res.labelid);
        }
        this.formData.labelid2 = res.labelid2 ? res.labelid2 : "";
        if (res.labelid2) {
          this.handleChangeLabel2(res.labelid2);
        }
        this.formData.labelid3 = res.labelid3 ? res.labelid3 : "";
        this.formData.paytype = res.paytype ? res.paytype : "";

        this.loading = false;
      });
    },

    // 获取商品分类标签
    getShopLabel() {
      getCommondityLabel().then((res) => {
        this.allLabel = res;
        this.labelChilds1 = res;
        this.getDetail();
      });
    },
    // 触发一级分类，获取二级数据
    handleChangeLabel1(e) {
      let { allLabel } = this;
      allLabel.forEach((v) => {
        if (v.id == e) {
          this.labelChilds2 = v.childs2;
        }
      });
    },
    // 触发二级分类，获取三级数据
    handleChangeLabel2(e) {
      let { labelChilds2 } = this;
      labelChilds2.forEach((v) => {
        if (v.id == e) {
          this.labelChilds3 = v.childs3;
        }
      });
    },

    query() {
      let { formData } = this;
      if (formData.commodityname.length < 2) {
        this.$message.warning("请输入商品名称最少2个字符");
        return;
      }
      if (formData.shortname.length < 2) {
        this.$message.warning("请输入商品简称最少2个字符");
        return;
      }
      if (formData.shortname_e != "" && formData.shortname_e) {
        if (formData.shortname_e.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_m != "" && formData.shortname_m) {
        if (formData.shortname_m.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_y != "" && formData.shortname_y) {
        if (formData.shortname_y.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.shortname_t != "" && formData.shortname_t) {
        if (formData.shortname_t.length < 2) {
          this.$message.warning("请输入商品简称最少2个字符");
          return;
        }
      }
      if (formData.comtype == "" || formData.comtype == null) {
        this.$message.warning("请选择商品类型");
        return;
      }
      if (formData.labelid == "" || formData.labelid == null) {
        this.$message.warning("请选择商品分类");
        return;
      }
      if (formData.paytype == "" || formData.paytype == null) {
        this.$message.warning("请选择商品结算类型");
        return;
      }
      this.loading = true;
      editCommidity(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          // setTimeout(() => {
          //   message.close();
          //   history.back();
          // }, 1500);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.back();
          // }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({name: 'cManageIndex'})
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>